module.exports = __webpack_public_path__ + "img/logo-pagando-check.16891e3c.svg";